import AdminOperationsScreen from "../src/features/arrangements/screens/AdminOperationsScreen";

export default function RegistryScreen() {
  return <AdminOperationsScreen screenIdOverride="online-registry" />;
}
